import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

const AndroidIcon = (props: SVGProps<any>): ReactElement => {
  return (
    <BaseIcon
      {...props}
      height="1em"
      width="1.5em"
      viewBox="-4.126 -7.659 35.759 45.954"
    >
      <defs id="defs38">
        <linearGradient
          gradientUnits="userSpaceOnUse"
          y2="21.86"
          x2="-5.9"
          y1="1.87"
          x1="14.09"
          id="linear-gradient"
        >
          <stop id="stop4" stopColor="#008eff" offset="0" />
          <stop id="stop6" stopColor="#008fff" offset=".01" />
          <stop id="stop8" stopColor="#00acff" offset=".26" />
          <stop id="stop10" stopColor="#00c0ff" offset=".51" />
          <stop id="stop12" stopColor="#00cdff" offset=".76" />
          <stop id="stop14" stopColor="#00d1ff" offset="1" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          y2="15.32"
          x2="-2.37"
          y1="15.32"
          x1="26.45"
          id="linear-gradient-2"
        >
          <stop id="stop17" stopColor="#ffd800" offset="0" />
          <stop id="stop19" stopColor="#ff8a00" offset="1" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          y2="45.15"
          x2="-9.41"
          y1="18.05"
          x1="17.69"
          id="linear-gradient-3"
        >
          <stop id="stop22" stopColor="#ff3a44" offset="0" />
          <stop id="stop24" stopColor="#b11162" offset="1" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          y2="3.81"
          x2="8.92"
          y1="-8.29"
          x1="-3.19"
          id="linear-gradient-4"
        >
          <stop id="stop27" stopColor="#328e71" offset="0" />
          <stop id="stop29" stopColor="#2d9571" offset=".07" />
          <stop id="stop31" stopColor="#15bd74" offset=".48" />
          <stop id="stop33" stopColor="#06d575" offset=".8" />
          <stop id="stop35" stopColor="#00de76" offset="1" />
        </linearGradient>
      </defs>
      <g transform="translate(.004)" id="g58">
        <g id="g56">
          <path
            id="path40"
            d="M.55.48A2.39 2.39 0 0 0 0 2.15v26.34a2.41 2.41 0 0 0 .55 1.67l.09.09 14.75-14.76v-.35L.64.39z"
            fill="url(#linear-gradient)"
          />
          <path
            id="path42"
            d="m20.31 20.41-4.92-4.92v-.35l4.92-4.91.11.06 5.83 3.31c1.67.94 1.67 2.49 0 3.44l-5.83 3.31z"
            fill="url(#linear-gradient-2)"
          />
          <path
            id="path44"
            d="m20.42 20.35-5-5L.55 30.16a2 2 0 0 0 2.45.07l17.39-9.88"
            fill="url(#linear-gradient-3)"
          />
          <path
            id="path46"
            d="M20.42 10.29 3 .4A1.93 1.93 0 0 0 .55.48l14.84 14.84z"
            fill="url(#linear-gradient-4)"
          />
          <path
            id="path48"
            d="M20.31 20.24 3 30.06a2 2 0 0 1-2.39 0l-.09.09.09.09a2 2 0 0 0 2.39 0l17.39-9.88z"
            opacity=".1"
          />
          <path
            id="path50"
            d="M.55 30A2.43 2.43 0 0 1 0 28.32v.17a2.41 2.41 0 0 0 .55 1.67l.09-.09z"
            opacity="0.07"
          />
          <path
            id="path52"
            d="m26.25 16.86-5.94 3.38.11.11L26.25 17a2.11 2.11 0 0 0 1.25-1.72 2.21 2.21 0 0 1-1.25 1.58z"
            opacity="0.07"
          />
          <path
            id="path54"
            d="m3 .58 23.25 13.19a2.2 2.2 0 0 1 1.25 1.55 2.09 2.09 0 0 0-1.25-1.72L3 .4C1.36-.54 0 .24 0 2.15v.17C0 .42 1.36-.37 3 .58z"
            fill="#fff"
            opacity=".3"
          />
        </g>
      </g>
    </BaseIcon>
  );
};
export default AndroidIcon;
